import FormulaWorkerFile from "@/workers/formula.worker.js";
import { wrap } from "comlink";

let singletonProxy = null;
let singletonInstance = null;
let userCount = 0;

export async function getWorker() {
  if (!singletonProxy) {
    singletonInstance = new FormulaWorkerFile();
    singletonProxy = wrap(singletonInstance);
  }
  userCount += 1;
  return singletonProxy;
}

export async function releaseWorker() {
  userCount = Math.max(0, userCount - 1);
  if (userCount === 0 && singletonProxy) {
    try {
      if (singletonProxy.terminate) {
        await singletonProxy.terminate();
      }
    } catch (e) {
      // ignore
    }
    try {
      if (singletonInstance && singletonInstance.terminate) {
        singletonInstance.terminate();
      }
    } catch (e) {
      // ignore
    }
    singletonProxy = null;
    singletonInstance = null;
  }
}




